// extracted by mini-css-extract-plugin
export var orderSummary = "_ql-0";
export var showMoreLessButton = "_ql-1";